__webpack_require__.p = "https://acmeg.org.af/db/";